import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Button,
  createStyles,
  makeStyles,
  withStyles,
  Theme,
  List,
  ListItem,
  Tooltip,
  Switch,
} from "@material-ui/core";

import { useVehicle } from "context";
import { useUpdateVehicle } from "rest";
import { InformationIcon } from "components";
// const wv = "/assets/images/wv.jpg";
const wv = "/assets/images/pendant.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: 12,
      fontSize: 20,
    },
    description: {
      marginBottom: 12,
      fontSize: 14,
    },
    media: {
      width: 200,
      height: 140,
    },
    details: {
      display: "flex",
    },
    content: {
      padding: "16px !important",
      flex: "1 0 auto",
    },
    disabledDiv: {
      pointerEvents: "none",
      opacity: "0.7",
      transition: "0.5s",
      maxWidth: 345,
    },
    root: {
      maxWidth: 345,
    },
  })
);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

// const RedSwitch = withStyles({
//   switchBase: {
//     color: "#FF0000 !important",
//   },
//   checked: { color: "#54AE36 !important" },
//   track: {},
// })(Switch);

const RedSwitch = withStyles({
  switchBase: {
    color: "#FF0000",
  },
  checked: {},
  track: {},
})(Switch);

export const PendantVehicleCard = ({ openPendantVehicleForm, saveVehicles }) => {
  const classes = useStyles();

  const { card1, card2, card3, prev, vehicles, setChecked, setSavedVehicle, setCheckedE } = useVehicle();

  const { mutate: updateVehicle } = useUpdateVehicle({
    onSuccess: () => {
      setSavedVehicle(false);
      setChecked(true);
      setTimeout(() => {
        setChecked(false);
      }, 5000);
    },
    onError: () => {
      setCheckedE(true);
      setTimeout(() => {
        setCheckedE(false);
      }, 5000);
    },
  });
  const handlePendantActive = (e: any) => {
    let updateVehicleObject = {
      lengthInM: vehicles.lengthInM.replace(",", "."),
      numberplate: vehicles.numberplate.toString(),
      pendantLengthInM: vehicles.pendant.lengthInM.replace(",", "."),
      pendantNumberplate: vehicles.pendant.numberplate.toString(),
      isPendantActive: e.target.checked,
      carLengthInM: vehicles.car.lengthInM.replace(",", "."),
      carNumberplate: vehicles.car.numberplate.toString(),
      isCarActive: vehicles.car.isCarActive,
      isVehicleActive: vehicles.isVehicleActive,
      hasMoto: vehicles.hasMoto,
      hasBike: vehicles.hasBike,
      hasTent: vehicles.hasTent,
    };

    updateVehicle(updateVehicleObject);
  };

  const removePendant = () => {
    let updateVehicleObject = {
      lengthInM: vehicles.lengthInM.replace(",", "."),
      numberplate: vehicles.numberplate.toString(),
      pendantLengthInM: "",
      pendantNumberplate: "",
      isPendantActive: false,
      carLengthInM: vehicles.car.lengthInM.replace(",", "."),
      carNumberplate: vehicles.car.numberplate.toString(),
      isCarActive: vehicles.car.isCarActive,
      isVehicleActive: vehicles.isVehicleActive,
      hasMoto: vehicles.hasMoto,
      hasBike: vehicles.hasBike,
      hasTent: vehicles.hasTent,
    };

    updateVehicle(updateVehicleObject);
  };

  return (
    <Card elevation={card2} className={card1 === 5 || card3 === 5 ? classes.disabledDiv : classes.root}>
      <CardContent className={card2 === 5 ? classes.disabledDiv : ""}>
        <Typography style={{ fontWeight: "bold" }} variant="h5" component="h2" color="primary">
          Wohnwagen/Anhänger
        </Typography>
      </CardContent>

      <CardMedia
        // className={classes.mediaX}
        component="img"
        alt="Vehicle"
        height="200"
        image={wv}
        title="Vehicle"
      />
      <CardContent className={card2 === 5 ? classes.disabledDiv : ""}>
        <Grid
          container
          spacing={2}
          style={prev?.hasPendant ? { paddingBottom: "12px" } : { paddingBottom: "0px" }}
        >
          <Grid item md={6}>
            <Button
              onClick={openPendantVehicleForm}
              variant="contained"
              disableElevation
              color="primary"
              style={{ width: "100%" }}
            >
              Bearbeiten
            </Button>
          </Grid>
          <Grid item md={6}>
            <Button
              disabled={!prev?.hasPendant}
              onClick={removePendant}
              variant="contained"
              disableElevation
              style={{ width: "100%" }}
            >
              Löschen
            </Button>
          </Grid>
        </Grid>
        {prev?.hasPendant && (
          <Grid container spacing={4} className={card2 === 5 ? classes.disabledDiv : ""}>
            <List aria-label="Information">
              <ListItem style={{ paddingTop: "8px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="primary">
                  Kennzeichen:
                </Typography>
              </ListItem>
              <ListItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="textPrimary">
                  {prev?.pendant.numberplate}
                </Typography>
              </ListItem>
              <ListItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="primary">
                  Länge in Meter:
                </Typography>
              </ListItem>
              <ListItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="textPrimary" style={{ paddingRight: "75px" }}>
                  {`${prev?.pendant.lengthInM} Meter`}
                </Typography>
                <RedSwitch
                  checked={prev?.pendant.isPendantActive}
                  onChange={(e: any) => handlePendantActive(e)}
                  id={"isPendantActive"}
                  name="checkedB"
                  // style={{
                  //   marginLeft: "75px",
                  // }}
                  color="primary"
                />
                <HtmlTooltip
                  title={
                    <>
                      <span>
                        <p>Bitte wählen Sie ihre Fahrzeuge für die Reservierung</p>
                      </span>
                    </>
                  }
                >
                  <InformationIcon style={{ fill: "green", marginLeft: "10px" }} />
                </HtmlTooltip>
              </ListItem>
            </List>
          </Grid>
        )}
      </CardContent>
    </Card>
  );

  // return (
  //   <Card className={card1 === 5 ? classes.disabledDiv : ""} elevation={card2}>
  //     <div className={classes.details}>
  //       <CardMedia className={classes.media} image={wv} title="Pendant" />
  //       <CardContent className={classes.content}>
  //         <Typography className={classes.title} color="primary" gutterBottom>
  //           {prev?.pendant.numberplate}
  //         </Typography>
  //         <Typography className={classes.description} color="primary" gutterBottom>
  //           {prev?.pendant.lengthInM}
  //         </Typography>
  //         <Grid container spacing={2} className={card2 === 5 ? classes.disabledDiv : ""}>
  //           <Grid item md={6}>
  //             <Button
  //               onClick={openPendantVehicleForm}
  //               size="small"
  //               variant="contained"
  //               disableElevation
  //               color="primary"
  //               style={{ width: "100%" }}
  //             >
  //               Bearbeiten
  //             </Button>
  //           </Grid>
  //           <Grid item md={6}>
  //             <Button
  //               onClick={removePendantVehicle}
  //               size="small"
  //               variant="contained"
  //               disableElevation
  //               style={{ width: "100%" }}
  //             >
  //               Löschen
  //             </Button>
  //           </Grid>
  //         </Grid>
  //       </CardContent>
  //     </div>
  //   </Card>
  // );
};
